<template>
  <div class="gift-card-value">
    <span class="gift-card-value__label">Gift Card</span>
    <span class="gift-card-value__amount">{{ amount_label }}</span>
  </div>
</template>

<script>
  export default {
    name: 'gift-card-value',

    props: {
      // taglio scelto, in euro. Resta null dove non c'è ancora una scelta da
      // mostrare: al visitatore del login-gate la card si fa solo vedere
      amount: {
        type: Number,
        default: null,
      },
    },

    computed: {
      amount_label() {
        if (this.amount === null) return '€ --';
        return `€${this.amount}`;
      },
    },
  };
</script>

<style lang="scss" scoped>

  // riga valore dentro la gift card blu: label a sinistra, importo a destra
  .gift-card-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $white;

    &__label {
      font-size: $font-size-base * 1.875;
      font-weight: $vb-font-weight-semibold;
    }

    &__amount {
      font-size: $font-size-base * 2.25;
      font-weight: $vb-font-weight-semibold;
    }
  }
</style>
